<template>
  <div id="orcamento">
    <div class="container">
      <div class="row">
        <b-form v-if="step === 1" class="card-orcamento">
          <div class="title">
            <h2>Orçamento de prestação de serviço</h2>
          </div>
          <div class="row">
            <pulse-loader
              :loading="loading"
              :color="color"
              :size="size"
              class="vue-loader"
            ></pulse-loader>
            <div class="col-md-6 col-12">
              <div class="form-group input-group">
                <vue-select
                  :clearable="false"
                  :options="optionsEstados"
                  label="uf"
                  placeholder="ESTADO"
                  @input="onChangeEstados"
                  class="vue-select-estado"
                  v-model="form.estado"
                  required
                >
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group input-group">
                <vue-select
                  :clearable="false"
                  :options="optionsCidades"
                  label="no_municipio"
                  placeholder="CIDADE"
                  @input="onChangeCidades"
                  class="vue-select-cidade"
                  v-model="form.cidade"
                  required
                >
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
            </div>

            <div class="col-md-6 col-12">
              <div class="form-group input-group flex-column">
                <div>
                  Quantidade eSF
                  <span
                    v-b-tooltip.hover
                    title="Equipe de Saúde da Familia"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </div>
                <input
                  name="quantidade_esf"
                  v-model="form.quantidade_esf"
                  class="form-control text-right"
                  type="number"
                  required
                  @blur="apenasInteiros($event.target.value, 'quantidade_esf')"
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group input-group flex-column">
                <div>
                  Quantidade eAP 20 horas
                  <span
                    v-b-tooltip.hover
                    title="Equipe de Atenção Primária"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </div>
                <input
                  name="quantidade_eap20h"
                  v-model="form.quantidade_eap20h"
                  class="form-control text-right"
                  type="number"
                  required
                  @blur="
                    apenasInteiros($event.target.value, 'quantidade_eap20h')
                  "
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group input-group flex-column">
                Quantidade eAP 30 horas
                <input
                  name="quantidade_eap30h"
                  v-model="form.quantidade_eap30h"
                  class="form-control text-right"
                  type="number"
                  required
                  @blur="
                    apenasInteiros($event.target.value, 'quantidade_eap30h')
                  "
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group input-group flex-column">
                Por quantos meses deseja contratar?
                <input
                  name="quantidade_meses"
                  v-model="form.quantidade_meses"
                  class="form-control text-right"
                  type="number"
                  required
                  @blur="
                    apenasInteiros($event.target.value, 'quantidade_meses')
                  "
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <label for="datepicker-full-width"
                >Em que data deseja começar?</label
              >
              <input
                class="form-control"
                v-model="form.data_inicio"
                type="date"
              />
            </div>
            <div class="container-botoes col-md-12 col-12 text-center mt-3">
              <b-button type="button" variant="primary" @click="voltar()"
                >Voltar</b-button
              >
              <b-button type="button" variant="primary" @click="orcamento()"
                >Avançar</b-button
              >
            </div>
          </div>
        </b-form>
        <!-- Página 2 -->
        <div v-if="step === 2" class="card-orcamento">
          <div class="title">
            <h2>Orçamento de prestação de serviço</h2>
          </div>
          <h4 class="mb-4">Quais serviços você deseja</h4>
          <ul class="lista" style="list-style: none">
            <li>
              <b-form-checkbox
                id="checkbox-1"
                v-model="feedBack"
                name="feedBack"
                :disabled="true"
              >
                eSUS Feedback
              </b-form-checkbox>
            </li>
            <li>
              <b-form-checkbox
                id="checkbox-4"
                v-model="meaNaAps"
                name="meaNaAps"
              >
                M & A na Aps
              </b-form-checkbox>
            </li>
            <li>
              <b-form-checkbox
                id="checkbox-2"
                v-model="pecOnline"
                name="pecOnline"
              >
                e-SUS PEC Online
              </b-form-checkbox>
            </li>
            <li>
              <b-form-checkbox
                id="checkbox-3"
                v-model="treinamento.ativo"
                name="pecOnline"
              >
                Treinamento e-SUS PEC/CDS
              </b-form-checkbox>

              <ul v-if="treinamento.ativo === true" style="list-style: none">
                <li>
                  <b-form-group>
                    <b-form-radio
                      v-model="treinamento.tipo"
                      name="Online"
                      value="Online"
                      >Online</b-form-radio
                    >
                    <b-form-radio
                      v-model="treinamento.tipo"
                      name="Presencial"
                      value="Presencial"
                      >Presencial</b-form-radio
                    >
                  </b-form-group>
                </li>
              </ul>
            </li>
          </ul>

          <div class="row">
            <div class="container-botoes col-md-12 col-12 text-center mt-5">
              <b-button type="button" variant="primary" @click="voltar(1)"
                >Voltar</b-button
              >
              <b-button type="button" variant="primary" @click="avancar(3)"
                >Avançar</b-button
              >
            </div>
          </div>
        </div>
        <!-- Página 3 -->
        <div v-if="step === 3" class="card-orcamento">
          <div class="title">
            <h2>Orçamento de prestação de serviço</h2>
          </div>
          <ul class="lista">
            <li>Estado: {{ this.$store.state.orcamento.estado }}</li>
            <li>Cidade: {{ this.$store.state.orcamento.cidade }}</li>
            <li>
              Equipes de Saúde:
              <ul>
                <li>{{ this.$store.state.orcamento.quantidade_esf }} eSF</li>
                <li>
                  {{ this.$store.state.orcamento.quantidade_eap20h }} eEAp 20
                  horas
                </li>
                <li>
                  {{ this.$store.state.orcamento.quantidade_eap30h }} eEAP 30
                  horas
                </li>
              </ul>
            </li>
            <li>
              Serviços:
              <ul>
                <li>eSUS Feedback</li>
                <li v-if="this.meaNaAps === true">M & A na Aps</li>
                <li v-if="this.pecOnline === true">e-SUS PEC Online</li>
                <li v-if="treinamento.ativo === true">
                  Treinamento e-SUS PEC/CDS {{ treinamento.tipo }}
                </li>
              </ul>
            </li>
            <li>
              Contratar por
              {{ this.$store.state.orcamento.quantidade_meses }} meses
            </li>
            <li>Iniciar em {{ this.$store.state.orcamento.data_inicio }}</li>
          </ul>
          <div class="row">
            <div class="container-botoes col-md-12 col-12 text-center mt-4">
              <b-button type="button" variant="primary" @click="voltar(2)"
                >Voltar</b-button
              >
              <b-button type="button" variant="primary" @click="avancar(4)"
                >Avançar</b-button
              >
            </div>
          </div>
        </div>
        <div v-if="step === 4" class="card-orcamento">
          <div class="title">
            <h2>EMPRESA</h2>
          </div>
          <h4 class="mb-4 title-empresa">
            Escolha a empresa, acréscimos e tipo de contratação
          </h4>
          <ul class="lista" style="list-style: none">
            <li>
              <div class="empresas">
                <b-form-group>
                  <b-form-radio
                    v-model="form.empresaOrcamento"
                    name="biatic"
                    value="biatic"
                  >
                    Biatic
                  </b-form-radio>
                  <b-form-radio
                    v-model="form.empresaOrcamento"
                    name="esusfeedback"
                    value="esusfeedback"
                  >
                    eSUS Feedback
                  </b-form-radio>
                </b-form-group>
              </div>
              <div class="acrescimo-parcela">
                <b-form-checkbox v-model="form.acrescimo" name="acrescimo">
                  Acréscimo de 6%
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="form.parcelaImplantacao"
                  name="parcela"
                >
                  Acrescentar parcela de implantação
                </b-form-checkbox>
              </div>
              <div class="contratacao">
                <b-form-group>
                  <b-form-radio
                    v-model="form.primeiraContratacao"
                    name="primeiraContratacao"
                    value="primeira"
                  >
                    Primeira contratação
                  </b-form-radio>
                  <b-form-radio
                    v-model="form.primeiraContratacao"
                    name="renovacaoContratacao"
                    value="renovacao"
                  >
                    Renovação de contratação
                  </b-form-radio>
                </b-form-group>
              </div>
            </li>
          </ul>
          <div class="row">
            <div class="container-botoes col-md-12 col-12 text-center mt-3">
              <b-button type="button" variant="primary" @click="voltar(3)"
                >Voltar</b-button
              >
              <b-button type="button" variant="primary" @click="verOrcamento()"
                >Ver orçamento</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
export default {
  name: 'Orcamento',
  components: {
    PulseLoader,
    'vue-select': VueSelect,
  },
  data() {
    return {
      treinamento: {
        ativo: null,
        tipo: null,
      },

      feedBack: null,
      meaNaAps: false,
      pecOnline: false,
      step: 1,
      form: {
        estado: '',
        cidade: '',
        quantidade_esf: '',
        quantidade_eap20h: '',
        quantidade_eap30h: '',
        quantidade_meses: '',
        data_inicio: '',
        empresaOrcamento: '',
        acrescimo: false,
        parcelaImplantacao: false,
        primeiraContratacao: '',
        dadosSimulacao: null,
      },
      loading: false,
      optionsCidades: [],
      optionsEstados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SE' },
        { uf: 'TO' },
      ],
      color: '#0D98BB',
      size: '40px',
    }
  },
  mounted() {
    if (localStorage.getItem('orcamento')) {
      localStorage.removeItem('orcamento')
    }
    this.form.quantidade_meses = 11

    /*   const SECONDS_PER_MINUTE = 60
    const MINUTES_PER_HOUR = 60
    const MILISECONDS_PER_SECOND = 1000
    const HOURS_PER_DAY = 168 */

    /*   const today = new Date()
    const oneDayInMiliSeconds =
      SECONDS_PER_MINUTE *
      MINUTES_PER_HOUR *
      MILISECONDS_PER_SECOND *
      HOURS_PER_DAY
    const tomorow = new Date(today.getTime() + oneDayInMiliSeconds)
    let diaNumber = tomorow.getDate()
    let mesNumber = tomorow.getMonth() + 1
    let anoNumber = tomorow.getFullYear()
    let dia = diaNumber.toString()
    let mes = mesNumber.toString()
    let ano = anoNumber.toString()
    if (dia.length < 2) {
      dia = '0' + dia
    }
    if (mes.length < 2) {
      mes = '0' + mes
    } */
    const dataAtual = new Date()
    var dia = dataAtual.getDate().toString().padStart(2, '0')
    var mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0')
    var ano = dataAtual.getFullYear().toString()
    this.form.data_inicio = `${ano}-${mes}-${dia}`
  },
  watch: {
    'treinamento.ativo'(value) {
      if (value !== true) {
        this.treinamento.tipo = null
      }
    },
  },
  computed: {
    min() {
      const dataAtual = new Date()

      const milisegundos = Date.parse(dataAtual)

      const data = new Date(milisegundos)

      const dataFormatada = data
        .toLocaleDateString('pt-BR')
        .split('/')
        .reverse()
        .join('-')
      return dataFormatada
    },
  },
  methods: {
    onChangeEstados(event) {
      this.loading = true
      this.form.cidade = null
      this.optionsCidades = []
      this.form.estado = event.uf
      this.$apiPublic
        .get('/orcamento/cidades/' + this.form.estado)
        .then((response) => {
          this.optionsCidades = response.data
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeCidades(event) {
      this.form.cidade = event.no_municipio
      this.form.dadosSimulacao = JSON.parse(event.dados)
      this.form.quantidade_esf = Number(this.form.dadosSimulacao.equipes_implantadas['eSF 40h'])
      this.form.quantidade_eap20h = Number(this.form.dadosSimulacao.equipes_implantadas['eAP 20h'])
      this.form.quantidade_eap30h = Number(this.form.dadosSimulacao.equipes_implantadas['eAP 30h'])
    },
    /*  validarEmail(email) {
      const regex = /^(\w+)@[a-z]+(\.[a-z]+){1,2}$/i
      return regex.test(email)
    } ,*/
    apenasInteiros(valor, nomeDoCampo) {
      const resultado = /^\d+$/.test(valor)

      if (!resultado) {
        this.form[nomeDoCampo] = ''
        const nomeFormatado = nomeDoCampo.replace('_', ' ')
        this.$toast.error(
          `O campo ${nomeFormatado} precisa ser número inteiro`,
          'Error:',
          {
            position: 'topRight',
          }
        )
      }
    },
    faixaPreco(qtdEquipe) {
      if (qtdEquipe === 1 || qtdEquipe === 2) return 305
      if (qtdEquipe === 3 || qtdEquipe === 4) return 275
      if (qtdEquipe === 5 || qtdEquipe === 6) return 225
      if (qtdEquipe === 7 || qtdEquipe === 8) return 205
      if (qtdEquipe === 9 || qtdEquipe === 10) return 185
      if (qtdEquipe > 10 && qtdEquipe <= 15) return 160
      if (qtdEquipe >= 16 && qtdEquipe <= 20) return 140
      if (qtdEquipe >= 21 && qtdEquipe <= 30) return 125
      if (qtdEquipe >= 31 && qtdEquipe <= 40) return 105
      if (qtdEquipe >= 41 && qtdEquipe <= 50) return 100
      if (qtdEquipe >= 51) return 95
    },
    faixaPrecoEsusPec(qtdEquipe) {
      if (qtdEquipe === 1 || qtdEquipe === 2) return 430
      if (qtdEquipe === 3 || qtdEquipe === 4) return 650
      if (qtdEquipe === 5 || qtdEquipe === 6) return 920
      if (qtdEquipe === 7 || qtdEquipe === 8) return 1020
      if (qtdEquipe === 9 || qtdEquipe === 10) return 1200
      if (qtdEquipe > 10 && qtdEquipe <= 15) return 1500
      if (qtdEquipe >= 16 && qtdEquipe <= 20) return 2000
      if (qtdEquipe >= 21 && qtdEquipe <= 30) return 2500
      if (qtdEquipe >= 31 && qtdEquipe <= 40) return 3000
      if (qtdEquipe >= 41 && qtdEquipe <= 50) return 3500
      if (qtdEquipe >= 51) return 5000
    },
    voltar(valor) {
      if (this.step === 1) {
        this.$router.push('/')
        return
      }
      this.step = valor
    },
    avancar(valor) {
      if (
        this.step === 2 &&
        this.treinamento.ativo === true &&
        this.treinamento.tipo === null
      ) {
        this.$toast.error('Escolha um tipo de treinamento', 'Error:', {
          position: 'topRight',
        })
        return
      }
      this.step = valor
    },
    validaData(d) {
      let data = d // pega o valor // substitui eventuais barras (ex. IE) "/" por hífen "-"
      /* data = data.replace(/\//g, '-') */

      let data_array = data.split('-') // quebra a data em array
      let dia = data_array[2]
      let mes = data_array[1]
      let ano = data_array[0]

      dia = data_array[2]
      mes = data_array[1]
      ano = data_array[0]

      let hoje = new Date()
      let d1hoje = hoje.getDate()
      let m1 = hoje.getMonth() + 1
      let a1 = hoje.getFullYear()

      let d1 = new Date(a1, m1, d1hoje)
      let d2 = new Date(ano, mes, dia)

      let diff = d2.getTime() - d1.getTime()
      diff = diff / (1000 * 60 * 60 * 24)
      if (
        this.form.data_inicio === null ||
        this.form.data_inicio === isNaN ||
        this.form.data_inicio === undefined ||
        this.form.data_inicio.length > 11 ||
        dia === undefined ||
        mes === undefined ||
        ano === undefined
      ) {
        return this.$toast.error('Data inválida', 'Error:', {
          position: 'topRight',
        })
      }
      if (dia > 31) {
        return this.$toast.error(`Não existe dia ${dia}!`, 'Error:', {
          position: 'topRight',
        })
      }
      if (mes > 12) {
        return this.$toast.error(`Não existe mês ${mes}!`, 'Error:', {
          position: 'topRight',
        })
      }
      if (diff < 0) {
        return this.$toast.error(
          'Data não pode ser anterior ao dia de hoje!',
          'Error:',
          {
            position: 'topRight',
          }
        )
      }
      return true
    },
    orcamento() {
      if (
        this.form.estado !== '' &&
        this.form.cidade !== '' &&
        this.form.quantidade_esf !== '' &&
        this.form.quantidade_eap20h !== '' &&
        this.form.quantidade_eap30h !== '' &&
        this.form.quantidade_meses !== '' &&
        this.form.data_inicio !== ''
      ) {
        if (this.validaData(this.form.data_inicio) === true) {
          const total_equipe =
            parseInt(this.form.quantidade_esf) +
            parseInt(this.form.quantidade_eap20h) +
            parseInt(this.form.quantidade_eap30h)

          const faixa_preco = this.faixaPreco(total_equipe)
          const faixa_preco_pec_online = this.faixaPrecoEsusPec(total_equipe)
          this.$store.commit('setOrcamento', {
            estado: this.form.estado,
            cidade: this.form.cidade,
            /*   cidade:
              this.form.cidade[0].toUpperCase() +
              this.form.cidade.slice(1).toLowerCase(), */
            quantidade_meses: parseInt(this.form.quantidade_meses),
            data_inicio: this.form.data_inicio.split('-').reverse().join('/'),
            total_equipe: total_equipe,
            faixa_preco: faixa_preco,
            quantidade_esf: parseInt(this.form.quantidade_esf),
            quantidade_eap20h: parseInt(this.form.quantidade_eap20h),
            quantidade_eap30h: parseInt(this.form.quantidade_eap30h),
            pec_online: this.pecOnline,
            mea_na_aps: this.meaNaAps,
            faixa_preco_pec_online: faixa_preco_pec_online,
            treinamento: {
              ativo: this.treinamento.ativo,
              tipo: this.treinamento.tipo,
            },
          })
          /*   if (localStorage.getItem('orcamento')) {
            localStorage.removeItem('orcamento')
          }
          const orcamento = {
            email: this.form.email,
            estado: this.form.estado,
            quantidade_esf: this.form.quantidade_esf,
            quantidade_eap20h: this.form.quantidade_eap20h,
            quantidade_eap30h: this.form.quantidade_eap30h,
            data_inicio: this.form.data_inicio
          }

          localStorage.setItem('orcamento', JSON.stringify(orcamento)) */

          this.step = 2
          /* const url = window.location.href.replace('orcamento', 'proposta')

        window.open(url) */
        }
      } else {
        this.$toast.error('Preencha todos os campos', 'Error:', {
          position: 'topRight',
        })
      }
    },
    verOrcamento() {
      if (this.form.empresaOrcamento === '') {
        this.$toast.error(
          'Você precisa escolher uma empresa para o orçamento',
          'Error:',
          {
            position: 'topRight',
          }
        )
        return
      }
      if (this.form.primeiraContratacao === '') {
        this.$toast.error(
          'Você precisa escolher um tipo de contratação',
          'Error:',
          {
            position: 'topRight',
          }
        )
        return
      }
      this.$store.commit('setDadosFormOrcamento', this.form)
      this.$store.commit('setEmpresa', this.form.empresaOrcamento)
      this.$store.commit('setAcrescimo', this.form.acrescimo)
      this.$store.commit('setParcelaImplantacao', this.form.parcelaImplantacao)
      this.$store.commit(
        'setPrimeiraContratacao',
        this.form.primeiraContratacao
      )

      if (this.pecOnline === true) {
        this.$store.commit('setPecOnlineOrcamento', {
          pec_online: true,
          treinamento: this.treinamento,
        })
      } else {
        this.$store.commit('setPecOnlineOrcamento', {
          pec_online: false,
          treinamento: null,
        })
      }

      if (this.treinamento.ativo === true) {
        this.$store.commit('setTreinamento', {
          ativo: true,
          tipo: this.treinamento.tipo,
        })
      } else {
        this.$store.commit('setTreinamento', {
          ativo: false,
          tipo: null,
        })
      }
      if (this.meaNaAps === true) {
        this.$store.commit('setMeaNaApsOrcamento', true)
      } else {
        this.$store.commit('setMeaNaApsOrcamento', false)
      }
      const url = window.location.href.replace('orcamento', 'proposta')

      window.open(url)
    },
  },
}
</script>

<style scoped>
::v-deep .custom-radio .custom-control-label::before {
  margin-top: 10px;
}
::v-deep .custom-radio .custom-control-label::after {
  margin-top: 10px;
}
::v-deep .custom-checkbox .custom-control-label::before {
  margin-top: 10px;
}
::v-deep .custom-checkbox .custom-control-label::after {
  margin-top: 10px;
}
#orcamento {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.row {
  /*   justify-content: center; */
  align-items: center;
}
.card-orcamento {
  width: 100%;
  box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 10%);
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1.25rem;
  position: relative;
  margin: 20px auto 40px;
}
.card-orcamento .title {
  border-bottom: 1px solid #f5f5f5;
  text-align: center;
  margin-bottom: 20px;
}
.card-orcamento .title h2 {
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-size: 25px;
}

.card-orcamento .vue-select-cidade,
.card-orcamento .vue-select-estado {
  width: 100%;
}

.btn {
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-size: 15px;
  padding: 0px 30px;
  text-transform: uppercase;
  font-weight: 700;
  box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);
}

.btn:hover {
  background: #0fafd7;
  color: #0056b3;
}
.icon-tooltip {
  margin-left: 10px;
}
.icon-tooltip i {
  font-size: 14px;
}
.container-botoes {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.lista {
  font-size: 28px;
  list-style: disc;
  margin-left: 35px;
}
.lista ul {
  list-style: disc;
  margin-left: 30px;
}
@media (max-width: 450px) {
  .container-botoes {
    display: flex;
    gap: 30px;
    align-items: center;
    flex-direction: column-reverse;
  }
}
.data {
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-left: 10px;
}
.form-control {
  width: 100% !important;
}
</style>
<style>
#orcamento
  #datepicker-full-width
  .b-calendar-grid-help
  .border-top
  .small
  .text-muted
  .text-center
  .bg-light {
  display: none !important;
}
#orcamento .small {
  display: none;
}
#orcamento #datepicker-full-width {
  border-radius: unset;
}
.title-empresa {
  margin-left: 34px;
}
.contratacao {
  margin-bottom: 1rem;
}
.acrescimo-parcela {
  border-bottom: 1px solid #eaeff4;
  border-top: 1px solid #eaeff4;
  padding: 10px 0px;
  margin-top: 13px;
  margin-bottom: 13px;
}
</style>
